module.exports = __webpack_public_path__ + "media/styles/images/svg/person-teal-2347e1457b8db8258ab0e3eb39bdad73.svg";